// Boundaries of grid cells of `step` separated by `gap`: every cell start
// (k*(step+gap)) and — with a gap — also its end (start+step), so the gaps
// show as boundary pairs.
export const getCellBoundaries = (
  size: number,
  step: number,
  gap: number
): number[] => {
  if (step <= 0) {
    return [];
  }

  const period = step + Math.max(0, gap);
  const positions: number[] = [];

  for (let start = 0; start <= size; start += period) {
    positions.push(start);

    if (gap > 0 && start + step <= size) {
      positions.push(start + step);
    }
  }

  return positions;
};
